import React from 'react';
import { volumes } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-177" data-mp="yvqx52trblli">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="ytob0tvq6cm2">
        <h2 className="text-center font-display text-[1.6rem] font-black uppercase leading-tight tracking-tight text-brand sm:text-[2.2rem]" data-id="element-179" data-mp="kx101n6xtlx5">
          What&apos;s Inside the Tennis Ready Pack?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-180" data-mp="b5deg2x2az3l">
          {volumes.map(item => <li key={item.volume} className="rounded-2xl border border-brand/10 bg-cream px-6 py-8" data-id="element-181" data-mp="fxy5wxshx03y">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-182" data-mp="74uko3blziyr">
                {item.emoji}
              </span>
              <p className="mt-4 text-[10px] font-bold uppercase tracking-[0.18em] text-lime-dark" data-id="element-183" data-mp="3ocg9onbelthr">
                {item.volume}
              </p>
              <h3 className="mt-2 font-display text-lg font-black uppercase leading-tight text-brand" data-id="element-184" data-mp="3tb9l8a74rafa">
                {item.title}
              </h3>
              <p className="mt-3 text-xs leading-relaxed text-ink/60" data-id="element-185" data-mp="37vckcy4gxvek">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}